import {
	Dialog
} from "client/Components";
import {
	ReactElement,
	useEffect,
	useState
} from "react";
import { localize } from "client_legacy/ndaw/culture";
import {
	AppUsageStatisticModel,
	AppUsageStatisticsSummary,
	getAppUsage
} from "client/Api/Analytics/analyticsStatistics";
import {
	AlertManager,
	useAlerts
} from "client/Hooks";
import { isCancelledError } from "client_legacy/ndaw/cancellation";
import { AnalyticsAppList } from "./AnalyticsAppList";


type AppUsageDialogProps = {
	onClose: () => void;
	selectedDaysRange: number;
};

export const AppUsageDialog = (props: AppUsageDialogProps): ReactElement => {
	const {
		onClose,
		selectedDaysRange
	} = props;

	const [isBusy, setIsBusy] = useState<boolean>(false);
	const [appUsage, setAppUsage] = useState<readonly AppUsageStatisticModel[]>([]);

	const alertManager: AlertManager = useAlerts();

	useEffect(
		(): EffectWithDestructorResult => {
			async function fetchData(signal: AbortSignal): Promise<void> {
				try {
					setIsBusy(true);

					const appUsageSummary: AppUsageStatisticsSummary = await getAppUsage(
						selectedDaysRange,
						null,
						signal
					);

					setAppUsage(appUsageSummary.appUsage);

					setIsBusy(false);
				} catch (e) {
					if (isCancelledError(e)) {
						return;
					}

					setIsBusy(false);

					alertManager.showError(
						localize("_GeneralErrorMessage")
					);
				}
			}

			const cancellation = new AbortController();

			fetchData(cancellation.signal);
			return () => cancellation.abort();

		},
		[alertManager, selectedDaysRange]
	);

	return (
		<Dialog
			hasBusyIndicator={isBusy}
			onClose={onClose}
		>
			<Dialog.Header
				title={localize("_AllUsedApps")}
				onClose={onClose}
			/>
			<Dialog.Body goesEdgeToEdge>
				<AnalyticsAppList
					items={appUsage}
				/>
			</Dialog.Body>
			<Dialog.Footer />
		</Dialog>
	);
};

AppUsageDialog.displayName = "AppUsageDialog";
